// Modal that shows the HTML returned by an action button whose handler is
// 'html_modal'. The HTML is author-supplied business-logic output; it is
// rendered inside a sandboxed <iframe> (no scripts, isolated styles) so a
// stray <script> or global CSS can't touch the host app.

interface Props {
  title?: string
  html: string
  onClose: () => void
}

const overlayStyle: React.CSSProperties = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
}

export default function HtmlResultModal({ title, html, onClose }: Props) {
  return (
    <div style={overlayStyle} onClick={onClose}>
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'var(--color-surface, #fff)', color: 'var(--color-text, #111)',
          borderRadius: 8, width: 'min(820px, 92vw)', maxHeight: '86vh',
          display: 'flex', flexDirection: 'column', overflow: 'hidden',
          boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
        }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '10px 16px', borderBottom: '1px solid var(--color-border, #e5e5e5)',
        }}>
          <span style={{ fontWeight: 600, fontSize: '0.9625rem' }}>{title || 'Result'}</span>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.1625rem', color: 'var(--color-text-secondary, #666)' }}
            title="Close">×</button>
        </div>
        <iframe
          title={title || 'Action result'}
          sandbox=""
          srcDoc={html || ''}
          style={{ border: 'none', width: '100%', height: '60vh', background: '#fff' }}
        />
      </div>
    </div>
  )
}
